// ============================================================================
// Input.jsx — Corelia UI v1.2
// Champ texte standard, harmonisé avec TextField & FormLayout
// ============================================================================
import theme from "../../../styles/theme";
import FormLayout from "./FormLayout";

const Input = ({
  label,
  labelPosition = "top",     // "top" | "left"
  labelWidth = null,          // largeur du label si labelPosition="left"
  align = "center",           // alignement vertical dans FormLayout
  value,
  onChange,
  placeholder,
  error,
  disabled,
  width = "100%",
  style = {},
  inputStyle = {},
}) => {
  return (
    <FormLayout
      label={label}
      labelPosition={labelPosition}
      labelWidth={labelWidth}
      align={align}
      width={width}
      style={style}
    >
      <input
        type="text"
        value={value ?? ""}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        style={{
          width: "100%",
          padding: `${theme.form.field.paddingV}px ${theme.form.field.paddingH}px`,
          fontFamily: theme.form.field.fontFamily,
          fontSize: theme.form.field.fontSize,
          fontWeight: theme.form.field.fontWeight,
          color: theme.form.field.color,
          background: disabled
            ? theme.form.disabled.background
            : theme.form.field.background,
          border: error
            ? `1px solid ${theme.colors.text.danger}`
            : theme.form.field.border,
          borderRadius: theme.form.field.borderRadius,
          minHeight: theme.form.field.minHeight,
          boxSizing: "border-box",
          outline: "none",
          lineHeight: 1.3,
          transition: "border-color 0.2s ease",
          cursor: disabled ? "not-allowed" : "text",
          ...inputStyle,
        }}
        onFocus={(e) => {
          if (disabled) return;
          e.target.style.border = theme.form.focus.borderColor;
          e.target.style.boxShadow = theme.form.focus.boxShadow;
        }}
        onBlur={(e) => {
          e.target.style.border = error
            ? `1px solid ${theme.colors.text.danger}`
            : theme.form.field.border;
          e.target.style.boxShadow = "none";
        }}
      />

      {error && (
        <div
          style={{
            marginTop: theme.spacing.xs / 2,
            fontSize: theme.form.field.fontSize,
            color: theme.colors.text.danger,
            fontFamily: theme.form.label.fontFamily,
          }}
        >
          {error}
        </div>
      )}
    </FormLayout>
  );
};

export default Input;
